import MealService from "@/services/MealService.js";

const state = {
  contentView: 0,
  mealsearch: "",
  filterKategorien: [],
  mealList: [],
  mealCategories: [],
  meal: null,
  allergene: [
    {
      text: "Getreide (A)",
      value: "A"
    },
    {
      text: "Krebstiere (B)",
      value: "B"
    },
    {
      text: "Eier (C)",
      value: "C"
    },
    {
      text: "Fisch (D)",
      value: "D"
    },
    {
      text: "Erdnüsse (E)",
      value: "E"
    },
    {
      text: "Sojabohnen (F)",
      value: "F"
    },
    {
      text: "Milch (G)",
      value: "G"
    },
    {
      text: "Schalenfrüchte (H)",
      value: "H"
    },
    {
      text: "Sellerie (L)",
      value: "L"
    },
    {
      text: "Senf (M)",
      value: "M"
    },
    {
      text: "Sesam (N)",
      value: "N"
    },
    {
      text: "Schwefeldioxid und Sulfate (O)",
      value: "O"
    },
    {
      text: "Lupinen (P)",
      value: "P"
    },
    {
      text: "Weichtiere (R)",
      value: "R"
    }
  ],
  kategorien: ["Vorspeisen", "Hauptspeisen", "Desserts"]
};

const getters = {
  getMealCategories(state) {
    return state.mealCategories;
  },
  getMealList(state) {
    return state.mealList;
  },
  getCurrent(state) {
    return state.meal;
  },
  getAllergene(state) {
    return state.allergene;
  },
  getKategorien(state) {
    return state.kategorien;
  },

  getFilterKategorien(state) {
    return state.filterKategorien;
  },
  getMealSearch(state) {
    return state.mealsearch;
  },
  getContentView(state) {
    return state.contentView;
  }
};

const actions = {
  findMeals(name) {
    console.log("Search: " + name);
    return new Promise((resolve, reject) => {
      MealService.findMeals(name)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchMealCategories({ commit }) {
    return new Promise((resolve, reject) => {
      MealService.getMealCategories()
        .then(result => {
          commit("SET_CATEGORIES_LIST", result.data.data);
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchMealList({ commit }) {
    return new Promise((resolve, reject) => {
      MealService.getAll()
        .then(response => {
          commit("SET_MEAL_LIST", response.data.data);
          resolve(response);
        })
        .catch(error => {
          //console.log(error.response.data.error);
          reject(error);
        });
    });
  },
  fetchMeal({ commit }, id) {
    return new Promise((resolve, reject) => {
      MealService.get(id)
        .then(response => {
          commit("SET_MEAL", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteMeal({ commit }, id) {
    return new Promise((resolve, reject) => {
      MealService.delete(id)
        .then(result => {
          commit("REMOVE_MEAL", id);
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteSelectedMeals({ commit }, meals) {
    return new Promise((resolve, reject) => {
      let ids = [];
      meals.forEach(meal => {
        ids.push(meal._id);
      });
      MealService.deleteMeals(ids)
        .then(result => {
          meals.forEach(meal => {
            commit("REMOVE_MEAL", meal._id);
          });

          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const mutations = {
  SET_CATEGORIES_LIST(state, value) {
    state.mealCategories = value;
  },
  SET_MEAL_SEARCH(state, value) {
    state.mealsearch = value;
  },
  SET_CONTENT_VIEW(state, value) {
    state.contentView = value;
  },

  SET_FILTER_KATEGORIEN(state, value) {
    state.filterKategorien = value;
  },

  SET_MEAL_LIST(state, value) {
    state.mealList = value;
  },
  SET_MEAL(state, value) {
    state.meal = value;
  },
  REMOVE_MEAL(state, id) {
    state.mealList = state.mealList.filter(item => item._id !== id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
